import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeatureComponent } from './feature.component';
import { UserIsLoggedInGuard } from './user/guards/user.guard';
import { AdminGuard } from './admin/guards/admin.guard';

const routes: Routes = [
  {
    path: '',
    component: FeatureComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./landing/landing.module').then((m) => m.LandingModule),
      },

      {
        path: 'payment',
        loadChildren: () =>
          import('./payment/payment.module').then((m) => m.PaymentModule),
      },

      {
        path: 'user',
        canActivate: [UserIsLoggedInGuard],
        loadChildren: () =>
          import('./user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'admin',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'price-list',
        loadChildren: () =>
          import('./price-list/price-list.module').then(
            (m) => m.PriceListModule
          ),
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./faq/faq.module').then(
            (m) => m.FaqModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeatureRoutingModule { }
